



























































































import { Component, Watch } from 'vue-property-decorator';
import RecurringPaymentsProductManagementMixin
  from '@/components/product/recurringPayments/recurringPaymentsProductManagement/RecurringPaymentsProductManagementMixin';
import ChangeInformationAndDiscountSettingForm
  from '@/components/product/recurringPayments/ChangeInformationAndDiscountSettingForm.vue';
import {CompSelectBoxOption} from '@/components/common/CompSelectBox.vue';
import {
  ApplyStatusType, DeliveryCycleType, DiscountType,
  Mall, PostProductsRegularDeliveryRequest,
  ProductsSearchContent,
  SaleStatusType
} from 'supporter';
import { Getter } from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {
  FilteredProductsDataToPrepareForGridData,
  gridProps,
  RecurringPaymentsRegistrationGridDataItem,
  STATUS_ALLOWED_TO_REGISTER_RECURRING_PAYMENTS_PRODUCTS
} from '@/components/product/recurringPayments/RecurringPaymentsProductRegisterAssistant';
import { GridProps } from '@/components/product/recurringPayments/RecurringPaymentsProductRegisterAssistant';
import ItemTable from '@/components/common/ItemTable.vue';
import {ncpPopup} from '@/utils/ncp';
import _ from 'underscore';

@Component({
  components: {
    ChangeInformationAndDiscountSettingForm,
    CompSelectBox,
    ItemTable,
  }
})
export default class RecurringPaymentsProductRegister extends RecurringPaymentsProductManagementMixin {
  @Getter('mall/malls')
  private readonly malls!: Mall[];
  private noticeList: string[] = [1, 2].map(number => this.getI18nOfThis(`REGISTER_DESCRIPTION_${number}`));
  private deliveryCycles = '';
  private isUsedDiscount = false;
  private discountType: DiscountType = 'AMOUNT';
  private discountValue: string | null = null;
  private isInvalidDiscountValueFormat = false;
  private mallSelectDisabled = false;
  private mallNo: number = 0;
  private gridProps: GridProps = gridProps();
  private isItUnderwayToConfirmChangingDiscountInfo = false;

  // 상품 조회 팝업에서 끌어온 모든 데이터를 가지는 state
  private gridDataBucket: RecurringPaymentsRegistrationGridDataItem[] = [];

  @Watch('gridDataBucket')
  private setTotalCount() {
    this.gridProps.options.pageOptions.totalCount = this.gridDataBucket.length;
  }

  // '상품 조회 팝업에서' 끌어온 데이터로 페이지네이션을 구성하기 위한 과정
  private get gridDataBucketSplit(): RecurringPaymentsRegistrationGridDataItem[][] {
    const { perPage, totalCount } = this.gridProps.options.pageOptions;
    const paginationLength = Math.ceil(totalCount / perPage);
    const paginationNumbers = _.range(1, paginationLength + 1);
    const result = paginationNumbers.map(number => {
      return number === paginationLength ?
          this.gridDataBucket.slice((number - 1) * perPage, totalCount)
          :
          this.gridDataBucket.slice((number - 1) * perPage, number * perPage)
    })
    return result;
  }

  // 그리드의 현재 페이지에 들어가는 데이터
  private get gridData(): RecurringPaymentsRegistrationGridDataItem[] {
    return this.gridDataBucketSplit.length ?
        this.gridDataBucketSplit[this.gridProps.options.pageOptions.page - 1] : [];
  }

  private get mallOptions(): CompSelectBoxOption<number>[] {
    return this.malls.map(mall => ({
      name: mall.mallName, value: mall.mallNo
    }));
  }

  private mounted() {
    const firstCreatedMall = this.malls[0];
    this.mallNo = firstCreatedMall.mallNo;
    if (this.malls.length <= 1) {
      this.mallSelectDisabled = true;
    }
  }

  private beforeDestroy() {
    window.removeEventListener('message', this.handleReceiveMessage)
  }

  private setPageData(page: number = 1, size?: number) {
    if (size) {
      this.gridProps.options.pageSize = size.toString();
      this.gridProps.options.pageOptions.perPage = size;
    }
    this.gridProps.options.pageOptions.page = page;
  }

  private openProductSearchPopup(): void {
    const params = '&callbackParam=add&noConfirm=true&allBtn=true&allBtnWantOnePageData=true';
    const url = `/product/search/popup?mallNo=${this.mallNo}${params}`;
    ncpPopup(url, window.$t('EVENT_ADDFORM_PRODUCT__SEARCH'), 1250, 1024);
  }

  private handleReceiveMessage(event): void {
    if (event.origin !== window.location.origin || !event.data.productPopSearchMallProductsNosForAdd) return;

    const filteredProductsData = this.filterSearchedProductsData(event.data.data);
    setTimeout(() => {
      alert(this.getI18nOfThis('ADD_SUCCESS', {
        successCount: filteredProductsData.length.toString(),
        failureCount: (event.data.data.length  - filteredProductsData.length).toString(),
      }))
    }, 0)
    this.gridDataBucket = this.convertFilteredDataToGridData(filteredProductsData);
    
    window.removeEventListener('message', this.handleReceiveMessage)
  }

  private filterSearchedProductsData(searchedProductsData: ProductsSearchContent[]): FilteredProductsDataToPrepareForGridData {
    const simplifiedData = searchedProductsData
        .map(productData => _.pick(productData,
          'mallNo',
          'mallName',
          'mallProductNo',
          'productName',
          'partnerName',
          'applyStatusType',
          'saleStatusType',
          'salePrice',
          'optionType', // ('MAPPING' == 세트상품)
          'frontDisplayable', // 전시상태
          'onlyAccessUrl', // 프론트 미노출 여부
          'shippingAreaType', // 배송구분 ('MALL_SHIPPING_AREA' == 쇼핑몰 배송)
          'deliverable', // 배송여부
          'usesDeliveryDueDate', // 배송지정일 설정 여부,
    ))

    const filteredData = simplifiedData
      .filter(productData =>
        Object.entries(STATUS_ALLOWED_TO_REGISTER_RECURRING_PAYMENTS_PRODUCTS)
              .every(([key, allowedValue]) => productData[key] === allowedValue)
        && productData.optionType !== 'MAPPING'
      )

    return filteredData as FilteredProductsDataToPrepareForGridData;
  }

  private convertFilteredDataToGridData(filteredData: FilteredProductsDataToPrepareForGridData): RecurringPaymentsRegistrationGridDataItem[] {
    let gridData: RecurringPaymentsRegistrationGridDataItem[] = filteredData.map(productData => {
      const gridDataItem: RecurringPaymentsRegistrationGridDataItem = {
        mallNo: productData.mallNo,
        mallName: productData.mallName,
        productNo: productData.mallProductNo,
        productName: productData.productName,
        partnerName: productData.partnerName,
        applyStatus: productData.applyStatusType as ApplyStatusType,
        saleStatusType: productData.saleStatusType as SaleStatusType,
        salePrice: productData.salePrice,
        discountedPrice: this.getDiscountedPrice(productData.salePrice, this.discountType, Number(this.discountValue))
      }

      return gridDataItem;
    });

    if (this.isUsedDiscount) {
      const discount = {
        type: this.discountType,
        value: Number(this.discountValue),
      }
      gridData = gridData.map(gridDataItem => ({ ...gridDataItem, discount }))
    }

    return gridData;
  }

  private getDiscountedPrice(targetValue: number, discountType: DiscountType, discountValue: number): number {
    const discountAmount = discountType === 'AMOUNT' ?
      discountValue : targetValue * ( discountValue / 100 );

    return targetValue - discountAmount;
  }

  @Watch('discountType')
  @Watch('discountValue')
  @Watch('isUsedDiscount')
  private checkIfYouWantToReset(): void {
    if (!this.gridProps.options.pageOptions.totalCount || this.isItUnderwayToConfirmChangingDiscountInfo) return;
    // confirm 진행중에 일어나는 Watch 발동은 무시시키기
    this.isItUnderwayToConfirmChangingDiscountInfo = true;

    const prevDiscountType = this.gridData[0].discount?.type;
    const prevDiscountValue = this.gridData[0].discount?.value?.toString();
    const prevIsUsedDiscount = Boolean(prevDiscountType) && Boolean(prevDiscountValue);

    this.$nextTick(() => {
      if (confirm(this.getI18nOfThis('CHANGE_DISCOUNT_INFO_CONFIRM_TEXT'))) {
        this.discountValue = null;
        this.resetGridDataBucket();
      }
      else {
        this.discountType = (prevDiscountType ?? 'AMOUNT') as DiscountType;
        this.discountValue = prevDiscountValue ?? null;
        this.isUsedDiscount = prevIsUsedDiscount;
      }
      this.$nextTick(() => {
        this.isItUnderwayToConfirmChangingDiscountInfo = false;
      })
    })
  }

  @Watch('mallNo')
  private confirmChangingMallNoWhenThereAreGridData(): void {
    if (!this.gridProps.options.pageOptions.totalCount || this.isItUnderwayToConfirmChangingDiscountInfo) return;

    this.isItUnderwayToConfirmChangingDiscountInfo = true;

    const prevMallNo = this.gridData[0].mallNo;
    this.$nextTick(() => {
      if (confirm(this.getI18nOfThis('CHANGE_MALL_CONFIRM_TEXT'))) {
        this.resetGridDataBucket();
      }
      else {
        this.mallNo = prevMallNo;
      }
      this.$nextTick(() => {
        this.isItUnderwayToConfirmChangingDiscountInfo = false;
      })
    })
  }


  // validation 사용 시 이 컴포넌트와 bind 필요
  private validations: { [key: string]: () => boolean } = {
    confirmDiscountValueFormat: function(): boolean {
      const isNoInput = !this.discountValue;
      if (this.isInvalidDiscountValueFormat) {
        alert(this.getI18nOfThis('PLEASE_CHECK_INPUT'))
        if (isNoInput) {
          this.$refs['recurringPaymentsProductRegisterForm'].$refs['discountValue'].focus();
        }
      }
      return !this.isInvalidDiscountValueFormat
    },
    validateDeliveryCycles: function (): boolean {
      if (!this.deliveryCycles) {
        alert(this.getI18nOfThis('PLEASE_SELECT_DELIVERY_CYCLE'));
        return false;
      }
      return true;
    },
    validateDiscountAmountOverflow: function (): boolean {
      const isValid = this.gridDataBucket.every(productInfo => productInfo.discountedPrice >= 0);
      if (!isValid) {
        alert(this.getI18nOfThis('THERE_IS_PRODUCT_WITH_NEGATIVE_DISCOUNT_PRICE'));
      }
      return isValid;
    }
  }

  private validate(): boolean {
    return Object.values(this.validations).every(validation => validation.bind(this)())
  }

  private handleSearchProductBtnClick(): void {
    if (!this.validations.confirmDiscountValueFormat.bind(this)()) return;

    window.addEventListener('message', this.handleReceiveMessage)
    this.openProductSearchPopup();
  }

  private handleDeleteSelectedProductsBtnClick(): void {
    const checkedRows = (this.$refs.itemTable as ItemTable).gridFunction('getCheckedRows');

    if (confirm(this.getI18nOfThis('DELETE_SELECTED_PRODUCTS_CONFIRM_TEXT'))) {
      if (!checkedRows.length) {
        alert(this.getI18nOfThis('PLEASE_SELECT_PRODUCTS_TO_DELETE'));
        return;
      }

      // TODO : 현재 filter 로직 시간복잡도가 O(NM) 이다. 추후 줄여보도록 하자
      this.gridDataBucket = this.gridDataBucket
          .filter((productData: RecurringPaymentsRegistrationGridDataItem) =>
              !checkedRows.some(row => row.mallNo === productData.mallNo && row.productNo === productData.productNo));
    }
  }

  private handleSaveBtnClick(): void {
    if (!confirm(this.getI18nOfThis('COMPLETE_REGISTRATION_CONFIRM_TEXT'))) return;
    if (!this.validate()) return;

    this.postProductsRegularDelivery().then(() => {
      alert(this.$t('ALERT_SAVE_SUCCESS'));
    }).catch(() => {
      return;
    })
  }

  private async postProductsRegularDelivery(): Promise<void> {
    const request: PostProductsRegularDeliveryRequest = this.makePostProductsRegularDeliveryRequest();

    try {
      await this.$api.postProductsRegularDelivery(request);
    } catch (e) {
      console.error(e);
      throw new Error(e);
    }
  }

  private makePostProductsRegularDeliveryRequest(): PostProductsRegularDeliveryRequest {
    const deliveryCycleInfo = {
      isAll: this.deliveryCycles === 'ALL',
      deliveryCycles: this.deliveryCycles === 'ALL' ? [] : this.deliveryCycles.split(',') as DeliveryCycleType[],
    }

    const data: PostProductsRegularDeliveryRequest['data'] = {
      mallNo: this.mallNo,
      productNos: this.gridDataBucket.map(productInfo => productInfo.productNo),
      deliveryCycleInfo: deliveryCycleInfo,
    }

    if (this.isUsedDiscount) {
      data['discount'] = {
        type: this.discountType,
        value: Number(this.discountValue),
      };
    }

    return { data };
  }

  private handleCancelBtnClick(): void {
    if (confirm(this.getI18nOfThis('CANCEL_REGISTRATION_CONFIRM_TEXT'))) {
      this.$router.push('/product/recurring-payment/management-prev');
    }
  }

  private resetGridDataBucket(): void {
    this.gridDataBucket = [];
    this.setPageData(1);
  }
}
